import { Grid } from '@material-ui/core'
import CreateConfiguration from 'elements/cashFlow/configuration/paymentMilestones/CreateConfiguration'
import UpdateConfiguration from 'elements/cashFlow/configuration/paymentMilestones/UpdateConfiguration'
import { Typography } from 'opensolar-ui'
import React from 'react'
import { useGetCashFlowConfigurations } from 'util/cashFlow/configuration'

type PropTypes = {
  financePartnerId: number
}

const LenderMilestones: React.FC<PropTypes> = (props) => {
  const configs = useGetCashFlowConfigurations(undefined, 1, 10, false, props.financePartnerId)
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Typography variant="body2SemiBold">Lender Milestones</Typography>
        {configs?.length ? (
          <UpdateConfiguration
            config={configs[0]}
            setIsUpdated={() => {}}
            setNewConfig={(conf) => {}}
            financePartnerId={props.financePartnerId}
          />
        ) : (
          <CreateConfiguration
            setIsUpdated={() => {}}
            setNewConfig={(conf) => {}}
            financePartnerId={props.financePartnerId}
          />
        )}
      </Grid>
    </Grid>
  )
}

export default LenderMilestones
